import { render, staticRenderFns } from "./SummaryStatisticsPage.vue?vue&type=template&id=0b0a38a4&"
import script from "./SummaryStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./SummaryStatisticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports